window.AcompanhamentoItemView = Backbone.Marionette.ItemView.extend({
    template: "#template-listar-acompanhamento-item",
    tagName: "tr",
    initialize: function(options) {
        this.app = options.app;
        this.parent = options.parent;
    }
});

window.AcompanhamentoView = Backbone.Marionette.CompositeView.extend({
    template: "#template-listar-acompanhamento",
    childView: AcompanhamentoItemView,
    childViewContainer: "#lista-acompanhamento-container",

    initialize: function(options) {
        this.app = options.app;
    },

    buildChildView: function(item, itemView) {

        var view = new itemView({
            model: item,
            app: this.app,
            parent: this
        });
        return view;
    },
});